

<template lang="pug">

span.animated-number {{ displayNumber }}

</template>


<script>
import leftPad from 'left-pad'
import {TweenMax, Linear} from 'gsap'

export default {
  name: 'animated-number',
  props: {
    number: {},
    time: {},
    fixed: {
      default: 0
    },
    pad: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      displayNumber: '0'
    }
  },
  mounted () {
    this.update(0, this.number)
  },
  methods: {
    update (from, to) {
      let _this = this
      let time = this.time || 0

      let tweeningNumber = {value: from}

      TweenMax.to(tweeningNumber, time / 1000, {
        value: to,
        ease: Linear.easeNone,
        onUpdateParams: [tweeningNumber],
        onUpdate: function (num) {
          _this.displayNumber = leftPad(num.value.toFixed(_this.fixed), _this.pad, '0')
        }
      })

    }
  },
  watch: {
    number (newVal, oldVal) {
      this.update(oldVal, newVal)
    }
  }
}
</script>


<style lang="sass" scoped>
@import "src/common.sass"

.animated-number

</style>



// WEBPACK FOOTER //
// AnimatedNumber.vue?8c54de70